var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',[(_vm.loading)?_c('OverlayBackground'):_vm._e(),_c('vs-button',{staticClass:"button-initial",attrs:{"flat":"","active":"","size":"large"},on:{"click":_vm.startActivity}},[_vm._v(" Comenzar Actividad ")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }